import { PersonProfileService } from '@openeducation/oe-it-services';

import { usePersonProfileNoService } from './use-person-profile-no-service';

export interface TeacherProps {
  personId: number | undefined;
  internal?: boolean;
}

export const usePersonLiteProfile = ({ personId }: TeacherProps) => {
  const {
    personProfile,
    isLoadingPersonProfile,
    isErrorPersonProfile,
    errorPersonProfile,
  } = usePersonProfileNoService({
    personId,
    extraQueryKey: 'lite-profile',
    getProfileById: PersonProfileService.getLiteProfileById,
  });

  return {
    personProfile,
    isLoadingPersonProfile,
    isErrorPersonProfile,
    errorPersonProfile,
  };
};
